// Formats a phone number progressively as user types → "555-555-5555"
// Handles paste, backspace, and non-digit input gracefully.
export const formatPhone = (value) => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 10);
  if (digits.length === 0) return "";
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

// Return the raw digits (e.g. for tel: links)
export const phoneDigits = (value) => String(value || "").replace(/\D/g, "");
